export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torsos-female-male-3637cd22a84923c4070f88d4aa49d0ca.svg";